module.exports = __webpack_public_path__ + "img/splash.77b21275.jpg";